module.exports = __webpack_public_path__ + "img/1524689770.0e3a08fb.jpg";